import { UserPlus, LogIn, Crown } from "lucide-react";

const steps = [
  { icon: UserPlus, label: "Register your account", step: "Step 1" },
  { icon: LogIn, label: "Login and use free tools", step: "Step 2" },
  { icon: Crown, label: "Upgrade to premium to unlock all tools", step: "Step 3" },
];

export default function HowItWorksSection() {
  return (
    <section data-testid="how-it-works-section" className="py-12 md:py-20 bg-green-50">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2
          data-testid="how-it-works-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          How It Works
        </h2>
        <p className="mt-2 text-center text-slate-500 text-sm">
          The process takes less than one minute.
        </p>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-3xl mx-auto">
          {steps.map((s, i) => (
            <div
              key={i}
              data-testid={`how-it-works-step-${i}`}
              className="flex flex-col items-center text-center"
            >
              <div className="relative">
                <div className="w-16 h-16 rounded-full bg-green-700 flex items-center justify-center shadow-lg shadow-green-900/20">
                  <s.icon className="w-7 h-7 text-white" />
                </div>
                <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-orange-500 text-white text-xs font-bold flex items-center justify-center">
                  {i + 1}
                </span>
              </div>
              <p className="mt-4 text-xs font-semibold text-green-600 uppercase tracking-wide">{s.step}</p>
              <p className="mt-1 text-sm md:text-base font-medium text-slate-800">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
